module.exports = __webpack_public_path__ + "media/whoosh.6d85746c.wav";